<mat-expansion-panel
  class="job-status-message-list"
  (afterExpand)="afterExpand()"
  (afterCollapse)="afterCollapse()"
>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="job-status-message-list__header">
        <div class="job-status-message-list__header-content">
          <div class="job-status-message-list__header-title">
            @if (message.result_object?.task_name_override) {
              <span>
                {{message.result_object.task_name_override}}
              </span>
            }
            @else {
              <span>
                {{message.task_name | translate}}
              </span>

              <span>
                {{message.fileTypeName}}
              </span>
            }
          </div>

          <div class="job-status-message-list__header-sub-title">
            <span class="tone-down-color">
              {{message.taskMetaData}}
            </span>
          </div>
        </div>

        <div class="job-status-message-list__status">
          @switch (message.statusType) {
            @case ('active') {
              <div class="medium-icon-bg active">
                <i class="icon-spinner job-status__spinner-icon color-white"></i>
              </div>
            }

            @case ('finished') {
              <div class="medium-icon-bg finished">
                <mat-icon class="job-status__finished-icon color-white">
                  done
                </mat-icon>
              </div>
            }

            @case ('failed') {
              <div class="medium-icon-bg failed">
                <mat-icon class="job-status__failed-icon color-white">
                  close
                </mat-icon>
              </div>
            }
          }

          @if (message.status !== 'failed') {
            <span class="tone-down-color">
              {{message.statusMessage}}
            </span>
          }
          @else {
            <a (click)="onShowError(message)">
              <span class="tone-down-color">
                {{'TRANS__JOB_STATUS__FAILED' | translate}}
              </span>
            </a>
          }
        </div>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <!-- content-->
  <div class="job-status-message-list__content tone-down-color">
    ID: {{message.queue_id}}
  </div>

  @if (message.task_type === 'reports' && (message.status === 'finished' || message.status === 'downloaded')) {
    <button
      mat-stroked-button
      color="primary"
      (click)="downloadReport(message.queue_id, message.filetype)"
    >
      <span>
        {{'TRANS__JOB_STATUS__DOWNLOAD' | translate}}
      </span>
    </button>
  }

  @if (message.progress === 100 && message.result_object?.report_id && message.result_object?.dms_id) {
    <button
      mat-stroked-button
      color="primary"
      (click)="downloadReportV2(message.result_object.report_id, message.result_object.dms_id)"
    >
      <span>
        {{'TRANS__JOB_STATUS__DOWNLOAD' | translate}}
      </span>
    </button>
  }

  @if (message.ref) {
    <ng-container>
      <a
        mat-stroked-button
        color="primary"
        [routerLink]="primusStateMapper.routerLinkFromState(message.ref)"
        [queryParams]="primusStateMapper.queryParams(message.refParams)"
        queryParamsHandling="merge"
        (click)="onClosePanel()"
      >
        <span>
          {{'TRANS__JOB_STATUS__OPEN' | translate}}
        </span>
      </a>
    </ng-container>
  }
</mat-expansion-panel>
